import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { backgroundSelectionStyles, borderSelectionStyles, hideNativeBrowserTextSelectionStyles } from './selectionStyles';
export var UnsupportedSharedCssClassName = {
  BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
  INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var unsupportedStyles = css(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(UnsupportedSharedCssClassName.BLOCK_CONTAINER, " > div, .").concat(UnsupportedSharedCssClassName.INLINE_CONTAINER, " > span:nth-of-type(2)"), {
  cursor: 'pointer'
}), '.ak-editor-selected-node', _defineProperty({}, "&.".concat(UnsupportedSharedCssClassName.BLOCK_CONTAINER, " > div, &.").concat(UnsupportedSharedCssClassName.INLINE_CONTAINER, " > span:nth-of-type(2)"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
backgroundSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
borderSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles])), '.danger', {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ak-editor-selected-node': _defineProperty({}, "&.".concat(UnsupportedSharedCssClassName.BLOCK_CONTAINER, " > div, &.").concat(UnsupportedSharedCssClassName.INLINE_CONTAINER, " > span:nth-of-type(2)"), {
    border: "1px solid ".concat("var(--ds-border-danger, #E2483D)"),
    backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
  })
}));